// src/api/api.js

import { getCurrentTenantSlug, getTenantApiUrl } from '../tenantConfig';

export async function getServices() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/tenant/services/`);
    const data = await res.json();
    if (data.success) {
      return data.data;
    }
    return [];
  } catch (error) {
    return [];
  }
}

export async function getFeatures() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/tenant/features/`);
    const data = await res.json();
    if (data.success) {
      return data.data;
    }
    return [];
  } catch (error) {
    return [];
  }
}

export async function getTeam() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/tenant/team/`);
    const data = await res.json();
    if (data.success) {
      return data.data;
    }
    return [];
  } catch (error) {
    return [];
  }
}

// export async function getBlogs() {
//   try {
//     const tenant = getCurrentTenantSlug();
//     const baseUrl = getTenantApiUrl(tenant);
//     const res = await fetch(`${baseUrl}/tenant/blogs/`);
//     const data = await res.json();
//     if (data.success) {
//       return data.data;
//     }
//     return [];
//   } catch (error) {
//     return [];
//   }
// }

export async function getTestimonials() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/tenant/testimonials/`);
    const data = await res.json();
    if (data.success) {
      return data.data;
    }
    return [];
  } catch (error) {
    return [];
  }
}

export async function getFaqs() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/tenant/faqs/`);
    const data = await res.json();
    if (data.success) {
      return data.data;
    }
    return [];
  } catch (error) {
    return [];
  }
}

export async function getTenantBranding() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/tenant/branding/`);
    const data = await res.json();
    if (data.success) {
      return data.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching tenant branding:', error);
    return null;
  }
}

export async function getAppointmentServices() {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/appointment/treatments/`);
    const data = await res.json();
    if (data.success) {
      return data.data; // This now returns { services: [...], clinic_timing: {...} }
    }
    return { services: [], clinic_timing: {} };
  } catch (error) {
    console.error('Error fetching appointment services:', error);
    return { services: [], clinic_timing: {} };
  }
}

export async function bookAppointment(appointmentData) {
  try {
    const tenant = getCurrentTenantSlug();
    const baseUrl = getTenantApiUrl(tenant);
    const res = await fetch(`${baseUrl}/appointment/appointments/book/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(appointmentData),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error booking appointment:', error);
    throw error;
  }
} 